import { hasRoleAdmin } from 'common/utility/userRoles';

import { SR_API_ACTION_UTILITY_PMS_INTEGRATION_PROMPT_TRACK } from 'api/utilityActionTypes';

export default async function trackPrompt({ state, utilityApiClient }, { utilityPartnerId }) {
  if (hasRoleAdmin(state.get('utilityUser')?.roles || [])) {
    return;
  }

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PMS_INTEGRATION_PROMPT_TRACK,
    state: state,
    payload: {
      utilityPartnerId,
    },
  });
}
